export const inputName = ["Name", "Email", "Phone number"];